import React from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import { Button } from "@/components/ui/button";
import { Download, Loader2 } from "lucide-react";

const REMARK_PLUGINS = [remarkGfm];

export function HelpDocBody({ loading, content, components }) {
  if (loading) {
    return (
      <div className="flex items-center justify-center py-24 text-slate-400 text-sm">
        <Loader2 className="w-4 h-4 mr-2 animate-spin" /> Cargando documentación...
      </div>
    );
  }
  if (!content) return <div className="text-slate-400 text-sm py-12 text-center">Documento no disponible.</div>;
  return (
    <article className="help-prose">
      <ReactMarkdown remarkPlugins={REMARK_PLUGINS} components={components}>{content}</ReactMarkdown>
    </article>
  );
}

export function HelpPdfButton({ onClick, disabled, downloading }) {
  return (
    <Button type="button" onClick={onClick} disabled={disabled} data-testid="help-download-pdf-btn"
      className="bg-orange-600 hover:bg-orange-700 text-white">
      {downloading
        ? <><Loader2 className="w-4 h-4 mr-2 animate-spin" /> Generando PDF...</>
        : <><Download className="w-4 h-4 mr-2" strokeWidth={1.75} /> Descargar PDF</>}
    </Button>
  );
}
